const shopUrl = window.Shopify?.routes?.root || "/";
const stampedStars = document.querySelectorAll('.product-meta__reviews .stamped-main-badge.stamped-stars-only');
const stampedCount = document.querySelectorAll('.product-meta__reviews .stamped-main-badge.stamped-count-only');
const stampedAverage = document.querySelectorAll('.product-meta__reviews .stamped-reviews_average');

// Novel UGC
const OVERLAY_EMBED_TYPE_UNIQUE_NAME = 'overlay';
const apiBaseUrl = 'https://eg2o7r7cs9.execute-api.us-west-2.amazonaws.com/prod';
const embedJsUrl = 'https://embed-js.benovel.com/embed/index.js';

document.addEventListener('DOMContentLoaded', async () => {
  const productBlocks = document.querySelectorAll('.section-product-picker .ftrp--product-block');
  const selectedProductBlock = document.querySelector('.section-product-picker .ftrp--product-block.is-selected');
  const breadcrumbProductTitle = document.querySelector('.breadcrumb__link--product-title');

  if (!productBlocks.length) return;

  if (selectedProductBlock) {
    const productHasOnlyDefaultVariant = selectedProductBlock.dataset.hasOnlyDefaultVariant === 'true';
    let variant_data;

    if (productHasOnlyDefaultVariant) {
      variant_data = {
        id: selectedProductBlock.dataset.variantId,
        name: selectedProductBlock.dataset.title,
        available: selectedProductBlock.dataset.variantAvailable,
      };
    }

    klBackInStock(productHasOnlyDefaultVariant, variant_data);

    if (typeof novel_ids !== "undefined" && novel_ids != null && selectedProductBlock.dataset.pid) {
      loadNovelWidget(selectedProductBlock.dataset.pid);
    }
  }

  productBlocks.forEach(block => {
    block.addEventListener('click', async () => {
      const handle = block.dataset.handle;
      const productId = block.dataset.pid;
      const productTitle = block.dataset.title;
      const productFeaturedImage = block.dataset.featuredImage;
      const productHasOnlyDefaultVariant = block.dataset.hasOnlyDefaultVariant === 'true';

      let variant_data;

      // UI selected state
      document.querySelectorAll('.product-picker--item.product-selected').forEach(el => {
        el.classList.remove('product-selected');
      });
      block.querySelector('.product-picker--item')?.classList.add('product-selected');

      if (breadcrumbProductTitle) {
        breadcrumbProductTitle.innerText = productTitle;
      }

      // Only reload sections that actually exist on this product page
      const sectionIdsToTry = [
        'MainProductSection',
        'productMediaBanners',
        'productComparison',
        'productComparisonV2',
        'featuredReviewsSection'
      ];

      const existingSections = sectionIdsToTry.filter(id => {
        const el = document.getElementById(id);
        return el && el.dataset.sectionId;
      });

      for (const secId of existingSections) {
        await loadNewProductSection(
          handle,
          secId,
          secId === 'MainProductSection' ? productId : null
        );
      }

      if (document.querySelector('.featured-reviews-carousel-slick')) {
        reloadFeaturedReviewsSection();
      }

      updateShopifyProductContext({ productId, handle });

      document.dispatchEvent(new CustomEvent('product-nav:changed', {
        detail: {
          handle,
          productId
        }
      }));

      updateStampedStarRating({
        id: productId,
        handle: handle,
        title: productTitle,
        reviewAverage: block.dataset.stampedAverage
      });

      // Re-init faq accordions
      $('.accordion-new').off('click', '.heading-new').on('click', '.heading-new', function () {
        $('.heading-new').not(this).removeClass('active');
        $(this).toggleClass('active').next().slideToggle();
        $('.contents-new').not($(this).next()).slideUp(300);
      });

      // Re-load Novel widget
      if (typeof novel_ids !== "undefined" && novel_ids) {
        loadNovelWidget(productId);
      }

      // Re-init upsell products
      if ($('.product-recommendations-slider').length) {
        $('.product-recommendations-slider.slick-initialized').slick('unslick');
        $('.product-recommendations-slider').not('.slick-initialized').slick({
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          arrows: false
        });
      }

      if (document.querySelector('.compare_product_section')) {
        updateProductComparison();
      }

      updateStampedMainWidget({
        id: productId,
        handle: handle,
        title: productTitle,
        featuredImage: productFeaturedImage
      });

      if (productHasOnlyDefaultVariant) {
        variant_data = {
          id: block.dataset.variantId,
          name: productTitle,
          available: block.dataset.variantAvailable,
        };
      }

      klBackInStock(productHasOnlyDefaultVariant, variant_data);
    });
  });
});

function reloadFeaturedReviewsSection() {
  $('.featured-reviews-carousel-slick').each(function () {
    const rawConfig = $(this).attr('data-slick-config');
    if (!rawConfig) return;

    const config = JSON.parse(rawConfig);
    const slidesDesktop = config.desktop;
    const slidesSmallDesktop = config.small_desktop;
    const slidesTablet = config.tablet;
    const slidesMobile = config.mobile;

    if ($(this).hasClass('slick-initialized')) {
      $(this).slick('unslick');
    }

    $(this).not('.slick-initialized').slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: slidesDesktop,
      slidesToScroll: Math.floor(slidesDesktop),
      prevArrow: $('.cx-slick-prev'),
      nextArrow: $('.cx-slick-next'),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: slidesSmallDesktop,
            slidesToScroll: Math.floor(slidesSmallDesktop)
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: slidesTablet,
            slidesToScroll: Math.floor(slidesTablet),
            lazyLoad: 'ondemand',
            cssEase: 'linear',
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: slidesMobile,
            slidesToScroll: Math.floor(slidesMobile),
            lazyLoad: 'ondemand',
            cssEase: 'linear',
          }
        }
      ]
    });
  });
}

async function loadNewProductSection(handle, secId, productId = null) {
  const oldSectionWrapper = document.getElementById(secId);

  if (!oldSectionWrapper) {
    console.warn(`Missing section wrapper: ${secId}`);
    return;
  }

  const sectionId = oldSectionWrapper.dataset.sectionId;

  if (!sectionId) {
    console.warn(`Missing data-section-id on: ${secId}`);
    return;
  }

  const currentUrl = new URL(window.location.href);
  const fetchUrl = new URL(`${window.Shopify?.routes?.root || '/'}products/${handle}`, window.location.origin);
  fetchUrl.searchParams.set('section_id', sectionId);

  try {
    oldSectionWrapper.style.transition = 'opacity 0.3s ease-in-out';
    oldSectionWrapper.style.opacity = '0.5';
    oldSectionWrapper.style.pointerEvents = 'none';

    const response = await fetch(fetchUrl.toString());
    const html = await response.text();

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newSection = doc.getElementById(secId);

    if (!newSection) {
      console.warn(`Fetched HTML did not contain section: ${secId}`);
      oldSectionWrapper.style.opacity = '1';
      oldSectionWrapper.style.pointerEvents = 'auto';
      return;
    }

    oldSectionWrapper.replaceWith(newSection);

    currentUrl.pathname = `/products/${handle}`;
    currentUrl.searchParams.delete('variant');
    currentUrl.searchParams.delete('section_id');
    history.pushState(null, '', currentUrl.toString());

    requestAnimationFrame(() => {
      newSection.style.transition = 'opacity 0.5s ease-in-out';
      newSection.style.opacity = '1';
      newSection.style.pointerEvents = 'auto';
    });

    if (secId === 'MainProductSection' && productId && typeof window.dynamaticLoadWidget === 'function') {
      window.dynamaticLoadWidget();
    }
  } catch (error) {
    console.error('PDP Section Swap Failed:', error);
  }
}

function updateStampedStarRating(data) {
  stampedStars.forEach(el => {
    el.dataset.id = data.id;
    el.dataset.productSku = data.handle;
    el.dataset.productTitle = data.title;
  });

  stampedCount.forEach(el => {
    el.dataset.id = data.id;
    el.dataset.productSku = data.handle;
    el.dataset.productTitle = data.title;
  });

  if (stampedAverage && data.reviewAverage) {
    stampedAverage.forEach(el => {
      el.innerText = data.reviewAverage;
    });
  }

  if (window.StampedFn && typeof window.StampedFn.loadBadges === "function") {
    window.StampedFn.loadBadges();
  }
}

function getNovelId(productId) {
  if (typeof novel_ids === "undefined" || !Array.isArray(novel_ids)) return null;
  const item = novel_ids.find(obj => obj[productId]);
  return item ? item[productId] : null;
}

async function loadNovelWidget(productId) {
  const embedElem = document.getElementById('novelUGCEmbed');
  const journeyId = getNovelId(productId);

  if (!embedElem || !journeyId) return;

  const loadEmbedScript = (release) => {
    window[`prefetchedJourneyRelease_${journeyId}`] = release;

    const script = document.createElement('script');
    script.setAttribute('src', embedJsUrl);
    script.setAttribute('journey-id', journeyId);
    script.setAttribute('async', '');

    embedElem.innerHTML = '';
    embedElem.appendChild(script);
  };

  try {
    const response = await fetch(
      `${apiBaseUrl}/api/v2/journeys/${journeyId}/releases?type=PUBLISH&sort=createdAt&order=DESC&size=1`
    );
    const releases = await response.json();
    if (releases?.[0]) {
      loadEmbedScript(releases[0]);
    }
  } catch (error) {
    console.log(error);
  }
}

function updateStampedMainWidget(data) {
  const widgetEl = document.getElementById("stamped-main-widget");
  if (!widgetEl || !data) return;

  widgetEl.setAttribute("data-product-id", data.id);
  widgetEl.setAttribute("data-name", data.title);
  widgetEl.setAttribute("data-url", `${shopUrl}products/${data.handle}`);
  widgetEl.setAttribute("data-image-url", data.featuredImage);
  widgetEl.setAttribute("data-product-sku", data.handle);

  if (window.StampedFn && typeof window.StampedFn.reloadUGC === 'function') {
    window.StampedFn.reloadUGC();
  }
}

function updateProductComparison() {
  $('.compare_product_section .product_item span.title')
    .off('click')
    .on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).next().toggle();
    });

  $('.pro_title_dropmenu li')
    .off('click')
    .on('click', function () {
      if ($('.product-comparison--details').css('display') === 'none') {
        $('.product-comparison--details').css('display', 'grid');
      }

      const d_id = $(this)[0].dataset.id;
      const product_title = $(this)[0].dataset.title;
      const productUrl = $(this)[0].dataset.url || '#';
      const productImgUrl = $(this)[0].dataset.img;
      const ddl_name = $(this)[0].closest('.pro_title_dropmenu').dataset.name;
      const container = document.querySelector(`.product-comparison--details .product_grid--item[data-name="${ddl_name}"]`);

      if (!container) return;

      container.innerHTML = "";
      const result = getProductFeatures(d_id, ddl_name);

      const titleFont = document.querySelector('.product_right .pro_title font');
      if (titleFont) titleFont.innerText = product_title;

      const productImg = document.querySelector(`.product_grid--control[data-name="${ddl_name}"] .product-comparison--img`);
      if (productImg && productImgUrl) {
        productImg.src = productImgUrl;
      }

      result.forEach(item => {
        const valueDiv = document.createElement('div');

        if (item.feature_title === 'What’s Included') {
          const listElement = createListFromString(item.value);
          valueDiv.appendChild(listElement);
        } else {
          valueDiv.textContent = item.value;
        }

        valueDiv.classList.add('pcomparison--value');
        valueDiv.classList.add(`pcomparison--${handleize(item.feature_title)}`);
        container.appendChild(valueDiv);
      });

      const shopDiv = document.createElement('div');
      shopDiv.classList.add('pcomparison--value', 'pcomparison--cta');
      shopDiv.innerHTML = `<a href="${productUrl}" class="shop_btn"><small>Shop ${product_title}</small></a>`;
      container.appendChild(shopDiv);
    });
}

function klBackInStock(hasOnlyDefaultVariant = false, variant_data = undefined) {
  const klBisBtn = document.querySelector('.kl-bis-api');
  const bisVariantId = document.querySelector('#klaviyo_bis_form #variant_id_input');
  const bisVariantName = document.querySelector('#klaviyo_bis_form #variant_name');

  if (!klBisBtn || !bisVariantId || !bisVariantName) return;

  if (hasOnlyDefaultVariant && variant_data) {
    klBisBtn.style.display = variant_data.available === 'false' ? 'block' : 'none';
    bisVariantId.value = variant_data.id;
    bisVariantName.innerText = variant_data.name;
  } else {
    document.addEventListener("variant:changed", function (event) {
      const variant = event.detail.variant;
      if (variant) {
        klBisBtn.style.display = variant.available === false ? 'block' : 'none';
        bisVariantId.value = variant.id;
        bisVariantName.innerText = variant.name;
      }
    });
  }
}

function updateShopifyProductContext({ productId, handle }) {
  if (window.ShopifyAnalytics?.meta) {
    window.ShopifyAnalytics.meta.product = {
      id: Number(productId),
      handle: handle
    };
  }

  if (window.meta) {
    window.meta.product = {
      id: Number(productId),
      handle: handle
    };
  }

  if (window.Shopify) {
    window.Shopify.product = {
      id: Number(productId),
      handle: handle
    };
  }
}